<template>

  <div>

    <div>

      <template>
        <div>
          <iframe style="width:100%;height:500px" :src="this.url" title="W3Schools Free Online Web Tutorials"></iframe>
        </div>
      </template>
      <div>
        <v-card-actions>
          <v-btn color="primary">Novo</v-btn>
        </v-card-actions>

      </div>

    </div>
  </div>
</template>

<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  data: () => ({

    url: '',
    html: '',
    empresa: {
      'nome_empresa': 'Instituto Superior Privado do Luena',
      'localidade': 'Luena',
      'zona': '',
      'provincia': '',
      'telefone': '999207671',
      'email': '',
      'detalhes': '',
      'contribuente': '5480006576',
      'NIF': '2401268340',

    },

    factura:
    {
      'factura_recibo': ls.get('itemsFaturaEstaticos').documento,
      'cliente': ls.get('itemsFaturaEstaticos').cliente[0].nome,
      'matricula': ls.get('itemsFaturaEstaticos').cliente[0].numero_matricula,
      'curso': ls.get('itemsFaturaEstaticos').cliente[0].descricao,
      'classe': ls.get('itemsFaturaEstaticos').cliente[0].classe_descricao,

      'items': ls.get("itemsFatura"),
      'total_pagar': ls.get('itemsFaturaEstaticos').valorApagar,
      'total_pago': ls.get('itemsFaturaEstaticos').valorPago,
      'troco': ls.get('itemsFaturaEstaticos').troco,
      'number_item': 1,
      'tiDQ': 'Documento Processado por programa validado',
      'utilizador': 'Pedro'
    },
    mes_ano: '',
    data_actual: '',
    dataHora: '',
    hora: '',
    formatter: 0
  }),
  created() {
    console.log(ls.get('itemsFaturaEstaticos'));
    this.data_hora()
    this.comporHtml()
  },

  methods: {
    data_hora() {
      let data = new Date()
      this.mes_ano = (data.getFullYear()) + (data.getMonth() + 1)
      this.data_actual = data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear())
      this.hora = (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
      this.dataHora = data.getDate() + '-' + (data.getMonth() + 1) + '-' + (data.getFullYear()) + 'T' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    },

    async facturagerarpdf(options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: 'https://ims.eftsk.com/writefile', //  http://localhost:8082  relatorios.softlineangola.com
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF

        this.isLoading = false
        this.url = 'https://ims.eftsk.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
      } catch (error) {
        this.isLoading = false
      }
    },
    formatMoney(value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    // Enviando a maior quantidade de linhas das tabelas (Items, Modo de Pagamento, Resumo de Imposto)

    comporHtml () {
      let item = ``
      let options = {
        'width': '90mm',
        'height': '150mm',
        'border': {
          // default is 0, units: mm, cm, in, px
          'right': '1mm',
          'left': '1mm'
        },
        'header': {
          'height': '7mm'
        },
        'footer': {
          'height': '5mm'
        }
      }
      this.factura.items.forEach(element => {
        item += `
                        <tr>
                  <td style="text-align:center">` + element.emolumento.produto + `</td>
                  <td style="text-align:center">` + element.mes + `</td>
                  <td style="text-align:center">` + element.multa + `</td>
                  <td style="text-align:center">` + element.qtd_compra + `</td>
                  <td style="text-align:center">` + utilitarios.IntegerToMoneyValueFatura(element.preco) + `</td>
                  <td style="text-align:center">` + utilitarios.IntegerToMoneyValueFatura(element.subtotal) + `</td>
                </tr>`
      })
      this.html = `
        <style>
        
  .footer {
    position:absolute;
    bottom:0;
    width:100%;
  }
  #content {
    display: table;
  }

  #pageFooter {
    display: table-footer-group;
     position:absolute;
    bottom:0;
    width:100%;
  }

  #pageFooter:after {
    counter-increment: page;
    content: counter(page);
  }
  .linha {
    border-bottom: 1px solid black;
    border-color: #808080;
    padding-top:2px
  }
   th, td {
      font-size:8px;
      
  }
  table, td, th {
  border: 0px solid;
}

  </style>
  <div style="text-align:left;margin:10px;margin-top:0px" class="invoice-box">
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
             <div>
   <span style="padding-top:1px!important">  <img src="https://ims.eftsk.com/readfile/bendizer.jpg" alt="Snow" style="width:50%; max-width:70px;" /></span>
    </div>
        </td>
         <td> 
        <strong style="font-size:20">` + this.empresa.nome_empresa + `</strong>
  <br><div style="font-size:10;text-align:center">` + this.empresa.localidade + `</div>
  <div style="font-size:10;text-align:center">` + this.empresa.telefone + `</div>
  <div style="font-size:10;text-align:center">` + this.empresa.email + `</div>
        </td>
         
    </tr>
    </table>
    <br>
      <table style="border:0px solid black;border-collapse: collapse;width:100%">
      <tr>
      <td colspan="8" style="text-align:center;">
       <div style="font-size: 15px;"><strong>RECIBO DE PAGAMENTO </strong>
        <br> <span style=" font-size: 10px;">` + this.factura.factura_recibo + `</span></div>
      </td>
      </tr>
      <tr>
      <td colspan="8"><div class="linha"></div> </td>
      </tr>

      <tr>
      <td colspan="4" >
     <div style="font-size: 10px;text-align:left"> 
      <strong>Nome:</strong> ` + this.factura.cliente + ` 
     </td>
     <td></div>
      </td>
      <td colspan="4" >
     <div style="font-size: 10px;text-align:left"> 
      <strong>Matricula: </strong> ` + this.factura.matricula + `
     </td>
     <td></div>
      </td>

      </tr>

      <tr>
      <td colspan="4" >
     <div style="font-size: 10px;text-align:left"> 
      <strong>Curso:</strong> ` + this.factura.curso + ` 
     </td>
     <td></div>
      </td>

      <td colspan="4" >
     <div style="font-size: 10px;text-align:left"> 
      <strong>ano:</strong> ` + this.factura.classe + ` 
     </td>
     <td></div>
      </td>
      </tr>
      <tr>
      <td colspan="7" >
     <div style="font-size: 10px;text-align:left"> 
      <strong>Forma de pag.:</strong> ` + ls.get('itemsFaturaEstaticos').formaPagamentoDescricao + `
     </td>
     </div>
      </td>
      </tr>

       <tr>
      <td colspan="8"><div class="linha"></div> </td>
      </tr>
      </table>
       <table width='100%'>
  <tr>
    <th>Emolumento</th>
    <th>Mês</th>
    <th>Multa</th>
    <th>Qtd.</th>
    <th>Unit.</th>
    <th>Valor.</th>
  </tr>
  ` + item + `
  <tr><td colspan="6"><div class="linha"></div> </td></tr>
  <tr style="background-color: #ddd;">
      <td colspan="5" style="text-align:left"> 
      <div style="font-size: 10px;"> <strong>Total a pagar </strong>  </div>  
      <div style="font-size: 10px;"> <strong>Total pago </strong>  </div>  
      <div style="font-size: 10px;"> <strong>Troco </strong>  </div>  
      </td> 
       <td style="text-align:center"> 
       <div style="font-size: 10px;">  ` + this.formatMoney(this.factura.total_pagar) + `  </div> 
       <div style="font-size: 10px;">  ` + this.formatMoney(this.factura.total_pago) + `  </div> 
       <div style="font-size: 10px;">  ` + this.formatMoney(this.factura.troco) + `  </div> 
        </td>   
      </tr>
      
      
</table>

       </table>
       <div class="footer" style=" font-size: 8px;text-align:center;"> 
      
      <span><strong>Operador:</strong>` + ls.get('itemsFaturaEstaticos').autor + `</span><br>
      <span> DATA/HORA: ` + this.data_actual + ` ` + this.hora + `</span> 
      <br>Gerado por Sistema ELTSYS
      </div>
</div>`
      this.facturagerarpdf(options)
    }
  }
}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
